module.exports = __webpack_public_path__ + "static/media/welcome-profile.a281fc2c.png";